module.exports = "/fast-coin/img/coin/anim/out_1/out_1_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_006.png
// module id = 2302
// module chunks = 5